<template>
    <!--
        ============================================================================
        ⚠️ 카카오 알림톡 심사 증빙용 임시 캡처 도구 ⚠️
        ============================================================================

        본 컴포넌트는 관리자 과금실패 상세 화면에 [신용카드(인증) 재결제] 버튼을
        추가하여, 클릭 시 별도 창(또는 탭)으로 스마트로 인증결제창 진입 페이지를
        연다. 카카오 알림톡 MSG-02 재심사 증빙 "카드사 5종 이상 노출" 캡처 용도.

        [본 파일의 성격]
        - 고넬로 실제 결제 플로우와 무관
        - SYSTEM_MANAGER + APP_ENV=local 조건에서만 렌더링 (blade 조건부)

        [소스 분석/리팩토링 시 주의]
        - resources/assets/js/components/app/kakao-review-capture/ 디렉토리 전체는 실기능 무관

        [관련 문서]
        - app/Http/Controllers/Web/System/KakaoReviewCapture/README.md

        작성일: 2026-04-24
        ============================================================================
    -->
    <span class="kakao-review-auth-pay-button">
        <button type="button"
                class="uk-button"
                :style="buttonStyle"
                :title="titleText"
                @click="openAuthPayWindow">
            <i class="material-icons uk-text-middle" style="font-size: 18px">credit_card</i>
            신용카드(인증) 재결제
        </button>
    </span>
</template>

<script>
export default {
    name: 'app-kakao-review-auth-pay',

    props: {
        billingId: {
            type: [Number, String],
            required: true,
        },
    },

    computed: {
        buttonStyle() {
            return {
                fontSize: '14px',
                padding: '0 24px',
                lineHeight: '40px',
                background: '#607d8b',
                color: '#fff',
                borderColor: '#455a64',
            };
        },
        titleText() {
            return '[개발용] 카카오 심사 증빙 캡처 — 스마트로 인증결제창 진입 (실기능 무관)';
        },
    },

    methods: {
        openAuthPayWindow() {
            const url = '/system/auth-pay/' + encodeURIComponent(this.billingId);
            const w = 800, h = 900;
            const top = (screen.availHeight - h) / 2;
            const left = (screen.availWidth - w) / 2;
            const features = [
                'width=' + w,
                'height=' + h,
                'top=' + top,
                'left=' + left,
                'scrollbars=yes',
                'resizable=yes',
            ].join(',');
            window.open(url, 'kakaoReviewAuthPay', features);
        },
    },
};
</script>
